import {
    Building2,
    Gavel,
    Banknote,
    Ruler,
    Globe,
    Scale,
    LineChart,
    ArrowRight,
    ThumbsUp,
    Users,
    ShieldCheck,
} from 'lucide-react';

const Services = () => {
    return (
        <section className="our-service-container-fb">
            <div className="our-service-header-fb">
                <h1 className="our-service-title-fb">Comprehensive Real Estate Services</h1>
                <p className="our-service-subtitle-fb">Tailored solutions for all your property needs</p>
            </div>

            {/* Services Grid */}
            <div className="our-service-grid-fb">
                <div className="our-service-card-fb">
                    <Building2 className="our-service-icon-fb" />
                    <h2 className="our-service-card-title-fb">Commercial Leasing</h2>
                    <p className="our-service-card-desc-fb">End-to-end support for leasing office and retail spaces.</p>
                </div>
                <div className="our-service-card-fb">
                    <Gavel className="our-service-icon-fb" />
                    <h2 className="our-service-card-title-fb">Property Legal Assistance</h2>
                    <p className="our-service-card-desc-fb">Navigate legal processes with expert property law services.</p>
                </div>
                <div className="our-service-card-fb">
                    <Banknote className="our-service-icon-fb" />
                    <h2 className="our-service-card-title-fb">Home Loan Support</h2>
                    <p className="our-service-card-desc-fb">Get the best financing options tailored to your needs.</p>
                </div>
                <div className="our-service-card-fb">
                    <Ruler className="our-service-icon-fb" />
                    <h2 className="our-service-card-title-fb">Interior & Vastu Consultation</h2>
                    <p className="our-service-card-desc-fb">Design your space in harmony with style and tradition.</p>
                </div>
                <div className="our-service-card-fb">
                    <Globe className="our-service-icon-fb" />
                    <h2 className="our-service-card-title-fb">NRI Real Estate Services</h2>
                    <p className="our-service-card-desc-fb">Dedicated services for property buying, selling, and managing for NRIs.</p>
                </div>
                <div className="our-service-card-fb">
                    <Scale className="our-service-icon-fb" />
                    <h2 className="our-service-card-title-fb">Property Valuation</h2>
                    <p className="our-service-card-desc-fb">Accurate property appraisal for sales, insurance, and loans.</p>
                </div>
                <div className="our-service-card-fb">
                    <LineChart className="our-service-icon-fb" />
                    <h2 className="our-service-card-title-fb">Real Estate Consulting</h2>
                    <p className="our-service-card-desc-fb">Strategic guidance for your real estate planning and goals.</p>
                </div>
            </div>

            {/* Benefits Section */}
            <div className="our-service-header-fb">
                <h1 className="our-service-title-fb">Why Choose Us?</h1>
                <p className="our-service-subtitle-fb">The advantages of working with us</p>
            </div>

            <div className="our-service-benefits-grid-fb">
                <div className="our-service-benefit-card-fb">
                    <ThumbsUp className="our-service-benefit-icon-fb" />
                    <h3>Trusted Expertise</h3>
                    <p>Years of industry experience and a proven record of success.</p>
                </div>
                <div className="our-service-benefit-card-fb">
                    <Users className="our-service-benefit-icon-fb" />
                    <h3>Local Market Knowledge</h3>
                    <p>Deep understanding of regional trends and buyer behavior.</p>
                </div>
                <div className="our-service-benefit-card-fb">
                    <ShieldCheck className="our-service-benefit-icon-fb" />
                    <h3>Transparent Process</h3>
                    <p>Clear communication and no hidden surprises, every step of the way.</p>
                </div>
            </div>

            {/* CTA */}
            <div className="our-service-cta-fb">
                <p className="our-service-benefit-fb">
                    Experience real estate redefined—where trust meets excellence.
                </p>
                <a href="/contact-us" className="our-service-button-fb">
                    Learn More About Our Services <ArrowRight size={18} />
                </a>
            </div>
        </section>
    );
};

export default Services;
